import nem from '../../static/js/nem-sdk/index'

export default {
  resetChain({ commit }) {
    commit('SET_NAMESPACES', [])
    commit('SET_NAMESPACE_INDEX', 0)
    commit('SET_ENDPOINT_INDEX', 0)
    commit('SET_BALANCE', '0')
  },
  setBalance({ commit }, balance) {
    commit('SET_BALANCE', balance)
  },
  setNamespaceIndex({ commit }, index) {
    commit('SET_NAMESPACE_INDEX', index)
  },
  setEndpointIndex({ commit }, index) {
    commit('SET_ENDPOINT_INDEX', index)
  },
  setNamespaces({ commit, rootState, state }) {
    const networkId = process.env.NETWORK_ID
    const webEndpoint = state.endpoints[networkId].web[state.endpointIndex]
    const address = rootState.wallet.address

    nem.com.requests.account.namespaces.owned(
      webEndpoint,
      address
    ).then((res) => {
      let namespaces = []
      if (res.data.length > 0) {
        res.data.forEach((data) => {
          namespaces.push(data.fqn)
        })
      } else {
        namespaces = [address.substr(0, 6)]
      }
      commit('SET_NAMESPACES', namespaces)
    })
    // commit('SET_NAMESPACES', [])
  }
}



// WEBPACK FOOTER //
// ./src/store/actions.js